<template>
  <div
    :class="[
      'item',
      { selected: $parent.selected && $parent.selected.value === value }
    ]"
    @click="selectedElem"
    ref="item"
  >
    {{ this.text }}
  </div>
</template>

<script>
export default {
  name: "BaseSelectItem",
  props: {
    value: {
      required: true
    },
    text: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      default: undefined
    };
  },
  mounted() {
    this.default = this.$parent.default;
    if (this.default !== undefined && this.default === this.value) {
      this.$parent.selected = { value: this.value, text: this.text };
    }
  },
  methods: {
    selectedElem() {
      this.$parent.selected = { value: this.value, text: this.text };
      this.$parent.closeDropdown();
    }
  },
  watch: {
    "$parent.default"() {
      this.default = this.$parent.default;
    },
    default() {
      if (this.default !== undefined && this.default === this.value) {
        this.$parent.selected = { value: this.value, text: this.text };
      }
      if (this.default === undefined) {
        this.$refs.item.classList.remove("selected");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";
.item {
  margin: 0px !important;
  height: 45px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-radius: 8px;
  font-size: 14px;
  &:hover {
    background: $color-primary !important;
    color: white !important;
  }
  &.onHover {
    background: $color-primary !important;
    color: white !important;
  }
  &.selected {
    color: $color-primary;
    background: rgba($color-light-primary, 0.2);
  }
}
</style>
